import React, { useState } from 'react';
import { Table } from "react-bootstrap";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { userProfileUpdateAsync } from '../../../Auth/_redux/auth.api';

let notificationList = [{
    "type": "EMAIL",
    "name": "USER_ORDER_PLACE_MAIL",
    "status": "INACTIVE"
},
{
    "type": "EMAIL",
    "name": "USER_ORDER_APPROVED",
    "status": "INACTIVE"
},
{
    "type": "EMAIL",
    "name": "USER_ORDER_REJECTED",
    "status": "INACTIVE"
},
{
    "type": "EMAIL",
    "name": "WITHDRAW_REQUEST_MAIL",
    "status": "INACTIVE"
},
{
    "type": "EMAIL",
    "name": "WITHDRAW_APPROVED",
    "status": "INACTIVE"
},
{
    "type": "EMAIL",
    "name": "WITHDRAW_REJECTED",
    "status": "INACTIVE"
},
{
    "type": "EMAIL",
    "name": "RESET_PASSWORD",
    "status": "INACTIVE"
},
{
    "type": "EMAIL",
    "name": "NEW_SUPPORT_TICKET",
    "status": "INACTIVE"
}]

export const NotificationSettingTab = () => {

    const { user } = useSelector(state => state.auth, shallowEqual);

    const [notifications, setNotifications] = useState(user && user.notifications && user.notifications.length ? user.notifications : notificationList)

    const dispatch = useDispatch();

    const onToggle = (e, notification) => {
        let status = e.target.checked ? "ACTIVE" : "INACTIVE"
        setNotifications(notifications.map(noti => {
            if (noti.name === notification.name) {
                return {
                    ...noti,
                    status,
                }
            }
            return noti;
        }))
    }

    const onUpdateClick = () => {
        dispatch(userProfileUpdateAsync({ notifications }, user._id))
    }

    return (
        <div className="tblmrgn mt-0 lwpddng cstm_pddng mn_height_500">
            <div className="max_660">
                <form className="row">
                    <div className="col-md-12">
                        <div className="mt-0">
                            <Table hover responsive className="mb-0 default_table mrpdng_tbl ntfctn_tbl">
                                <thead>
                                    <tr>
                                        <th>Notifications</th>
                                        <th>Email</th>
                                        {/* <th>SMS</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        notifications.map((notification, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        <h6>{notification.name}</h6>
                                                    </td>
                                                    <td>
                                                        <div className="ap_checkbox tblckcbx tblckcbx_sqr">
                                                            <input type="checkbox" name="checkbox" className="mr-2 checkbox"
                                                                id={index}
                                                                checked={notification.status === "ACTIVE"}
                                                                onChange={(e) => onToggle(e, notification)}
                                                            />
                                                            <label></label>
                                                        </div>
                                                    </td>
                                                    {/* <td>
                                                        <div className="ap_checkbox tblckcbx tblckcbx_sqr">
                                                        <input type="checkbox" name="checkbox" className="mr-2 checkbox" />
                                                        <label></label>
                                                        </div>
                                                    </td> */}
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </div>
                    <div className="col-md-12 text-center mt-15">
                        <button type="button" className="btn btn-def btn-defv4"
                            onClick={onUpdateClick}
                        >
                            <span>Update</span>
                        </button>
                    </div>
                </form>
            </div>
        </div >
    )
}